import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './TravelAppProper.jsx'
import versionManager from './utils/versionManager.js'
import deepLinkManager from './utils/deepLinkManager.js'
import nfcConfigManager from './utils/nfcConfigManager.js'
import migrationToIndexedDB from './utils/migrationToIndexedDB.js'
import { consumeReturnStatus } from './utils/googleDrive.js'
import { initDriveAutoBackup } from './utils/driveAutoBackup.js'
import './i18n'  // Initialize i18n
import './styles/index.css'

// Buffer polyfill for @react-pdf/renderer
import { Buffer } from 'buffer'
window.Buffer = Buffer

// Initialize app systems
console.log('🚀 DIAS Travel App starting...');

// Initialize version management
versionManager.initialize();

// Initialize NFC configuration
nfcConfigManager.loadConfig().then(() => {
  console.log('✅ NFC configuration loaded');
}).catch(error => {
  console.error('❌ Failed to load NFC configuration:', error);
});

// Initialize deep link handling
deepLinkManager.initialize().then(() => {
  console.log('✅ Deep link manager initialized');
}).catch(error => {
  console.error('❌ Failed to initialize deep link manager:', error);
});

// Kill stale force-reset flag that causes database deletion loop
localStorage.removeItem('datamanager_force_reset');

// Sprint 4C — consume the ?drive=… return after the Google Drive consent redirect
// (cleans the URL and flags the connection).
consumeReturnStatus();

// Sprint 4C — automatic Drive backups (text frequent + full scheduled on Wi-Fi).
initDriveAutoBackup();

// Initialize IndexedDB migration (runs once automatically)
migrationToIndexedDB.migrate().then(result => {
  if (result.success) {
    if (result.alreadyMigrated) {
      console.log('✅ IndexedDB: Already migrated');
    } else if (result.noData) {
      console.log('✅ IndexedDB: Fresh start - no data to migrate');
    } else {
      console.log('✅ IndexedDB: Migration completed successfully');
      console.log('   • Photos migrated:', result.stats?.photos || 0);
      console.log('   • Notes migrated:', result.stats?.notes || 0);
      console.log('   • Reflections migrated:', result.stats?.reflections || 0);
    }
  } else {
    console.error('❌ IndexedDB migration failed:', result.error);
  }
}).catch(error => {
  console.error('❌ Failed to run IndexedDB migration:', error);
});

// Initialize NFC test suite in development
if (import.meta.env.DEV) {
  import('./utils/nfcTestSuite.js').then(({ default: nfcTestSuite }) => {
    window.nfcTestSuite = nfcTestSuite;
    console.log('🧪 NFC Test Suite available at window.nfcTestSuite');
    console.log('🔗 Test page: http://localhost:3000/test-nfc.html');
  }).catch(error => {
    console.error('❌ Failed to load NFC test suite:', error);
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)